<template>
  <div class="carousel"
    :data-align="alignV"
    :data-align_image="alignH">
    <Carousel
      :autoplay="autoplay"
      :autoplayTimeout="duration"
      :loop="true"
      :perPage="1"
      :mouseDrag="true"
      :paginationPadding="4"
      :paginationActiveColor="'rgba(30,30,30,0.7)'"
      :paginationColor="'rgba(200,200,200,0.7)'">
      <Slide v-for="(slide, index) in carouselList" :key="index" class="carouselImg imgFrame" :style="imgRadius()">
        <SetLink
          v-if="!!slide.link && slide.link !== null"
          :linkTarget="slide.link"
          :lang="lang" />
        <img v-if="slide.value" :src="slide.value" alt="" />
        <div v-if="slide.dimmer" class="dimmer" :style="{backgroundColor: slide.dimmer}"></div>
        <button v-if="slide.enlarge" type="button" class="btnImageViewer" @click="imgView($event, slide.value)"><span class="blind">show image viewer</span></button>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'Gallery',
  props: [
    'item',
    'option',
    'detailData',
    'lang'
  ],
  components: {
    Carousel,
    Slide,
    SetLink
  },
  computed: {
    carouselList () {
      return this.item.filter(x => x.value !== '')
    },
    alignV () {
      return this.option.alignment
    },
    alignH () {
      return this.option.alignmentImage
    }
  },
  data () {
    let autoplay = typeof (this.option.auto) === 'undefined' ? true : this.option.auto
    let duration = typeof (this.option.duration) === 'undefined' ? 3000 : Number(this.option.duration)
    return {
      autoplay,
      duration
    }
  },
  methods: {
    imgView (e, src) {
      e.stopPropagation()
      this.$store.commit('setImgSrc', src)
    },
    imgRadius () {
      const detail = this.detailData.radius && this.detailData.radius.active ? this.detailData.radius : null
      const radius = detail ? `${detail.tl}px ${detail.tr}px ${detail.br}px ${detail.bl}px` : null
      return `border-radius: ${radius}`
    }
  }
}
</script>
